import * as React from "react";

import AccuracyTemplateService from "./accuracyTemplateService";
import * as M from "./models";
import { JSX } from "react";

/** A context for accuracy template retrieval. */
export const AccuracyTemplateContext = React.createContext<M.AccuracyTemplate>(null);

/** The set of props needed to render an AccuracyTemplateProvider. */
interface AccuracyTemplateProviderProps {
  children: React.ReactNode;
  onTemplateChange?: (template: M.AccuracyTemplate) => void;
  templateCollectionId: string;
  templateId: string;
}

/** Pre-built provider for accuracy templates. */
export function AccuracyTemplateProvider({ children, onTemplateChange, templateCollectionId, templateId }: AccuracyTemplateProviderProps): JSX.Element {
  const accuracyTemplateService = React.useMemo(() => new AccuracyTemplateService(), []);
  const [template, setTemplate] = React.useState<M.AccuracyTemplate>(null);

  const handleTemplateChange = React.useCallback((t: M.AccuracyTemplate) => {
    setTemplate(t);
    if (onTemplateChange) {
      onTemplateChange(t);
    }
  }, [setTemplate, onTemplateChange]);

  React.useEffect(() => {
    if (templateCollectionId && templateId) {
      accuracyTemplateService
        .getTemplateDetails(templateCollectionId, templateId)
        .then((handleTemplateChange), () => handleTemplateChange(null)); // TODO: Error boundary.
    }
  }, [templateCollectionId, templateId]);

  return (
    <AccuracyTemplateContext.Provider value={template}>
      {children}
    </AccuracyTemplateContext.Provider>
  );
}
